export const loginGetters = {
  /* ****************A*I********************* */

  getMsalInstance(state) {
    return state.msalInstance
  },
  getIsAuthenticated(state) {
    return state.isAuthenticated
  },
  getIsInitialized(state) {
    return state.isInitialized
  },
  getIsLoggedIn(state) {
    return state.isLoggedIn
  },
  getUserName(state) {
    return state.userName
  },
  getUserEmail(state) {
    return state.userEmail
  },
  getLoginType(state) {
    return state.loginType
  },
  getMicrosoftLogin(state) {
    return state.microsoftLogin || sessionStorage.getItem('microsoftLogin')
  },
  getGoogleLogin(state) {
    return state.googleLogin || sessionStorage.getItem('googleLogin')
  },
  getAdminuserInfo(state) {
    return state.adminuserInfo || sessionStorage.getItem('adminuserinfo')
  },
  getInteractionInProgress(state) {
    return state.interactionInProgress
  }
}
